"use strict";

exports.__esModule = true;
exports.TooltipContent = void 0;
var _react = _interopRequireDefault(require("react"));
var _utils = require("./utils");
var _styles = require("./styles");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var TooltipContent = exports.TooltipContent = function TooltipContent(props) {
  var active = props.active,
    payload = props.payload,
    xValueFormatter = props.xValueFormatter,
    yValueFormatter = props.yValueFormatter,
    chartType = props.chartType;
  if (!active || payload && payload.length === 0) {
    return null;
  }
  var xValue = xValueFormatter && payload && xValueFormatter(payload);
  var yValues = yValueFormatter && payload && yValueFormatter(payload);
  return /*#__PURE__*/_react["default"].createElement(_styles.TooltipWrapper, null, /*#__PURE__*/_react["default"].createElement(_styles.XValue, null, xValue || ""), yValues && yValues.map(function (yValue, index) {
    return /*#__PURE__*/_react["default"].createElement(_styles.YValueWrapper, {
      key: yValue ? yValue.name : index
    }, yValue.color && /*#__PURE__*/_react["default"].createElement(_styles.TooltipIcon, {
      backgroundColor: yValue.color,
      style: (0, _utils.getTooltipIconStyles)(chartType)
    }), /*#__PURE__*/_react["default"].createElement(_styles.YValueName, null, yValue ? yValue.name : ""), /*#__PURE__*/_react["default"].createElement(_styles.YValue, null, yValue ? yValue.value : ""));
  }));
};